(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // ============ FUNCIONES DEL BUSCADOR MEJORADO ============
  
  // 1. Cargar marcas dinámicamente desde Shopify
  async function loadDynamicBrands() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}collections.json?limit=50`);
      const data = await response.json();
      
      const brandsContainer = document.getElementById('dynamicBrandsContainer');
      brandsContainer.innerHTML = '';
      
      if (data.collections && data.collections.length > 0) {
        // Mostrar las primeras 5 colecciones como marcas
        data.collections.slice(0, 5).forEach(collection => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'search-tag-chip';
          chip.textContent = collection.title;
          chip.setAttribute('data-query', collection.title);
          chip.setAttribute('data-collection-handle', collection.handle);
          
          chip.addEventListener('click', (e) => {
            e.preventDefault();
            // Dirigir a la colección
            window.location.href = `${window.Shopify.routes.root}collections/${collection.handle}`;
          });
          
          brandsContainer.appendChild(chip);
        });
      } else {
        brandsContainer.innerHTML = '<p style="font-size: 1.2rem; color: #999;">No hay marcas disponibles</p>';
      }
    } catch (error) {
      console.error('Error cargando marcas:', error);
      document.getElementById('dynamicBrandsContainer').innerHTML = '<p style="font-size: 1.2rem; color: #999;">Error al cargar marcas</p>';
    }
  }
  
  // 2. Cargar categorías populares dinámicamente
  async function loadDynamicCategories() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}search/suggest.json?q=&resources[type]=product&resources[limit]=0`);
      const data = await response.json();
      
      const categoriesContainer = document.getElementById('dynamicCategoriesContainer');
      categoriesContainer.innerHTML = '';
      
      // Usar algunas categorías sugeridas o términos populares
      const popularCategories = ['Serum', 'Crema', 'Mascarilla', 'Limpiador', 'Protector Solar', 'Labios'];
      
      popularCategories.forEach(category => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'search-tag-chip';
        chip.textContent = category;
        chip.setAttribute('data-query', category);
        
        chip.addEventListener('click', (e) => {
          e.preventDefault();
          const searchInput = document.getElementById('headerSearchInput');
          searchInput.value = category;
          searchInput.dispatchEvent(new Event('input'));
        });
        
        categoriesContainer.appendChild(chip);
      });
    } catch (error) {
      console.error('Error cargando categorías:', error);
    }
  }
  
  // 3. Cargar productos sugeridos (desde la colección "Favoritos de Luana")
  async function loadSuggestedProducts() {
    try {
      // ⚠️ Ajusta este handle si el de tu colección es distinto
      const collectionHandle = 'favoritos-de-luana';

      const response = await fetch(`${window.Shopify.routes.root}collections/${collectionHandle}/products.json?limit=3`);
      const data = await response.json();

      const productsContainer = document.getElementById('suggestedProductsContainer');
      productsContainer.innerHTML = '';

      if (data.products && data.products.length > 0) {
        data.products.forEach(product => {
          const image = product.images && product.images.length > 0 ? product.images[0].src : 'https://via.placeholder.com/150';
          const price = product.variants && product.variants.length > 0 ? `S/ ${parseFloat(product.variants[0].price).toFixed(2)}` : '';
          const url = `${window.Shopify.routes.root}products/${product.handle}`;

          const productHTML = `
            <div class="search-product-item">
              <a href="${url}" style="text-decoration: none; color: inherit; display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
                <div>
                  <img src="${image}" alt="${product.title}">
                  <p class="search-product-title">${product.title}</p>
                  <p class="search-product-price">${price}</p>
                </div>
                <button type="button" class="search-add-btn" onclick="event.preventDefault(); window.addSearchItemToCart(this, '${url}');">Agregar al carrito</button>
              </a>
            </div>
          `;
          productsContainer.insertAdjacentHTML('beforeend', productHTML);
        });
      } else {
        productsContainer.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; font-size: 1.3rem; color: #999;">No hay productos disponibles</p>';
      }
    } catch (error) {
      console.error('Error cargando productos sugeridos:', error);
      document.getElementById('suggestedProductsContainer').innerHTML = '<p style="grid-column: 1 / -1; text-align: center; font-size: 1.3rem; color: #999;">Error al cargar productos</p>';
    }
  }
  
  // Función para agregar al carrito desde búsqueda
  window.addSearchItemToCart = function(button, productUrl) {
    const originalText = button.innerText;
    button.innerText = 'Cargando...';
    button.disabled = true;
    
    const cleanUrl = productUrl.split('?')[0];
    
    fetch(cleanUrl + '.js')
      .then(response => response.json())
      .then(product => {
        const variantId = product.variants[0].id;
        
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'items': [{
              'id': variantId,
              'quantity': 1
            }]
          })
        });
      })
      .then(response => {
        if (!response.ok) throw new Error('Error al agregar el producto');
        return response.json();
      })
      .then(cart => {
        button.innerText = '¡Agregado!';
        button.style.backgroundColor = '#6cc24a'; 
        
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(res => res.json())
          .then(data => {
             const bubble = document.querySelector('.cart-count-bubble');
             if (bubble) {
               bubble.innerHTML = '<span aria-hidden="true">' + data.item_count + '</span>';
             }
             
             document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
               bubbles: true
             }));
          });
        
        setTimeout(() => {
          button.innerText = originalText;
          button.style.backgroundColor = '';
          button.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error agregando al carrito:', error);
        button.innerText = 'Error / Agotado';
        setTimeout(() => {
          button.innerText = originalText;
          button.disabled = false;
        }, 2000);
      });
  };
  
  // ============ INICIALIZACIÓN ============
  
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }
  customElements.define('sticky-header', StickyHeader);
  // Cache de colecciones para detectar búsquedas de marca
let allCollectionsCache = [];

async function loadAllCollectionsForSearch() {
  try {
    const response = await fetch(`${window.Shopify.routes.root}collections.json?limit=250`);
    const data = await response.json();
    allCollectionsCache = data.collections || [];
  } catch (error) {
    console.error('Error cargando colecciones para búsqueda:', error);
  }
}

function normalizeText(text) {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

function findMatchingCollection(query) {
  const normalizedQuery = normalizeText(query);
  if (!normalizedQuery) return null;
  return allCollectionsCache.find(collection => {
    const title = normalizeText(collection.title);
    const handle = normalizeText(collection.handle);
    return title === normalizedQuery || handle === normalizedQuery || title.includes(normalizedQuery);
  });
}
  
  const initCustomHeaderFeatures = () => {
    // Cargar datos dinámicos al iniciar
    loadDynamicBrands();
    loadDynamicCategories();
    loadSuggestedProducts();

        loadAllCollectionsForSearch();

    const headerSearchForm = document.getElementById('headerSearchForm');
    if (headerSearchForm) {
      headerSearchForm.addEventListener('submit', function (e) {
        const query = mainSearchInput.value.trim();
        const matchedCollection = findMatchingCollection(query);
        if (matchedCollection) {
          e.preventDefault();
          window.location.href = `${window.Shopify.routes.root}collections/${matchedCollection.handle}`;
        }
      });
    }
    
    // Buscador Interactivo
    const searchInputs = document.querySelectorAll('.custom-search-input');
    const searchPanels = document.querySelectorAll('.search-dropdown-panel');
    const closeSearchBtns = document.querySelectorAll('.close-search-panel-btn');
    const mainSearchInput = document.getElementById('headerSearchInput');
    const clearSearchBtn = document.querySelector('.js-search-clear-btn');
    const searchGrid = document.querySelector('.search-products-grid');
    
    let debounceTimer;
    
    if (mainSearchInput && clearSearchBtn) {
      const toggleClearBtn = () => {
        clearSearchBtn.style.display = mainSearchInput.value.trim() !== '' ? 'flex' : 'none';
      };
      
      mainSearchInput.addEventListener('input', function() {
        toggleClearBtn();
        const query = this.value.trim();
        clearTimeout(debounceTimer);
        
        if (query.length === 0) {
          loadSuggestedProducts();
          return;
        }
        
        debounceTimer = setTimeout(() => {
          fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=3`)
            .then(response => response.json())
            .then(data => {
              const products = data.resources.results.products;
              if (products && products.length > 0) {
                let html = '';
                products.forEach(product => {
                  const image = product.image ? product.image : 'https://via.placeholder.com/150';
                  const price = product.price || '';
                  
                  html += `
                    <div class="search-product-item">
                      <a href="${product.url}" style="text-decoration: none; color: inherit; display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
                        <div>
                          <img src="${image}" alt="${product.title}">
                          <p class="search-product-title">${product.title}</p>
                          <p class="search-product-price">${price}</p>
                        </div>
                        <button type="button" class="search-add-btn" onclick="event.preventDefault(); window.addSearchItemToCart(this, '${product.url}');">Agregar al carrito</button>
                      </a>
                    </div>
                  `;
                });
                
                if (searchGrid) searchGrid.innerHTML = html;
              } else {
                if (searchGrid) {
                  searchGrid.innerHTML = `<p style="grid-column: 1 / -1; text-align: center; font-size: 1.4rem; color: #666; padding: 2rem 0;">No se encontraron productos para "${query}".</p>`;
                }
              }
            })
            .catch(error => console.error('Error en búsqueda:', error));
        }, 300);
      });
      
      toggleClearBtn();
      clearSearchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        mainSearchInput.value = '';
        toggleClearBtn();
        mainSearchInput.dispatchEvent(new Event('input')); 
        mainSearchInput.focus();
      });
    }
    
    searchInputs.forEach((input, index) => {
      const panel = searchPanels[index];
      if(panel) {
        input.addEventListener('focus', () => panel.classList.add('active'));
        document.addEventListener('click', (e) => {
          if (!input.contains(e.target) && !panel.contains(e.target) && (!clearSearchBtn || !clearSearchBtn.contains(e.target))) {
            panel.classList.remove('active');
          }
        });
      }
    });
    
    closeSearchBtns.forEach(btn => btn.addEventListener('click', (e) => { 
      e.preventDefault(); 
      searchPanels.forEach(p => p.classList.remove('active'));
    }));
    
    // Modal de Dirección
    const openAddrBtns = document.querySelectorAll('.js-open-address-modal');
    const closeAddrBtns = document.querySelectorAll('.js-close-address-modal');
    const addrOverlays = document.querySelectorAll('.js-address-modal-overlay');
    
    openAddrBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        addrOverlays.forEach(overlay => overlay.classList.add('active'));
      });
    });
    
    closeAddrBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        addrOverlays.forEach(overlay => overlay.classList.remove('active'));
      });
    });
    
    addrOverlays.forEach(overlay => {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) overlay.classList.remove('active');
      });
      
      const streetInput = overlay.querySelector('.js-addr-street');
      const numberInput = overlay.querySelector('.js-addr-number');
      const noNumberCheckbox = overlay.querySelector('.js-no-number');
      const saveBtn = overlay.querySelector('.js-save-address-btn');
      const addrCards = overlay.querySelectorAll('.address-option-card');
      
      addrCards.forEach(card => {
        card.addEventListener('click', () => {
          addrCards.forEach(c => { c.classList.remove('selected'); c.querySelector('input').checked = false; });
          card.classList.add('selected'); card.querySelector('input').checked = true;
        });
      });
      
      const checkAddrForm = () => {
        if (!streetInput || !numberInput || !saveBtn) return;
        const valid = streetInput.value.trim() !== '' && (numberInput.value.trim() !== '' || noNumberCheckbox.checked);
        saveBtn.classList.toggle('active', valid);
      };
      
      streetInput?.addEventListener('input', checkAddrForm);
      numberInput?.addEventListener('input', checkAddrForm);
      noNumberCheckbox?.addEventListener('change', () => {
        numberInput.value = ''; numberInput.disabled = noNumberCheckbox.checked; checkAddrForm();
      });
      
      saveBtn?.addEventListener('click', async function(e) {
        e.preventDefault();
        
        const addressData = {
          street: streetInput.value.trim(),
          number: numberInput.value.trim() || (noNumberCheckbox.checked ? 'S/N' : ''),
          reference: overlay.querySelector('[placeholder*="Piso"]')?.value.trim() || '',
          type: overlay.querySelector('.address-option-card.selected')?.getAttribute('data-type') || 'Mi casa',
          savedDate: new Date().toLocaleString()
        };

        const originalText = saveBtn.innerText;
        saveBtn.innerText = 'Guardando...';
        saveBtn.disabled = true;

        try {
          if (window.Shopify?.customer?.id) {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/account/addresses';
            form.style.display = 'none';

            const fields = {
              'address[address1]': `${addressData.street} ${addressData.number}`.trim(),
              'address[address2]': addressData.reference,
              'address[city]': 'Lima',
              'address[province]': 'Lima',
              'address[country]': 'PE',
              'address[zip]': '',
              'address[phone]': '',
              'address[company]': addressData.type
            };

            for (const [key, value] of Object.entries(fields)) {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = key;
              input.value = value;
              form.appendChild(input);
            }

            document.body.appendChild(form);
            saveBtn.innerText = '✓ Dirección guardada en tu cuenta';
            saveBtn.style.backgroundColor = '#6cc24a';
            saveBtn.style.color = '#ffffff';

            setTimeout(() => {
              form.submit();
            }, 1500);
            return;
          }

          localStorage.setItem('userAddress', JSON.stringify(addressData));
          
          const date = new Date();
          date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = `userAddress=${encodeURIComponent(JSON.stringify(addressData))}; ${expires}; path=/`;

          saveBtn.innerText = '✓ Dirección guardada';
          saveBtn.style.backgroundColor = '#ff96c5';
          saveBtn.style.color = '#ffffff';

          setTimeout(() => {
            overlay.classList.remove('active');
            saveBtn.innerText = originalText;
            saveBtn.style.backgroundColor = '';
            saveBtn.style.color = '';
            saveBtn.disabled = false;
            
            streetInput.value = '';
            numberInput.value = '';
            overlay.querySelector('[placeholder*="Piso"]').value = '';
            noNumberCheckbox.checked = false;
            numberInput.disabled = false;
          }, 2000);

        } catch (error) {
          console.error('Error:', error);
          
          localStorage.setItem('userAddress', JSON.stringify(addressData));
          const date = new Date();
          date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = `userAddress=${encodeURIComponent(JSON.stringify(addressData))}; ${expires}; path=/`;

          saveBtn.innerText = '✓ Guardado (sin conexión)';
          saveBtn.style.backgroundColor = '#ff96c5';

          setTimeout(() => {
            overlay.classList.remove('active');
            saveBtn.innerText = originalText;
            saveBtn.style.backgroundColor = '';
            saveBtn.disabled = false;
          }, 2000);
        }
      });
    });
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomHeaderFeatures);
  } else {
    initCustomHeaderFeatures();
  }

  } catch(e) { console.error(e); }
})();
})();
